import { clsx } from "clsx";
import { useTranslations } from "../../i18n";
import { Checkbox } from "../Checkbox";
import { Skeleton } from "../Skeleton";
import { useTableContext } from "./context";
import { TableHeaderCell } from "./TableHeaderCell";

type Props = {
  className?: string;
};

export function TableHeader({ className }: Props) {
  const { t } = useTranslations();
  const { columns, selection, loading, emptyState, gridTemplateColumns } =
    useTableContext();

  const showSelection = !!selection;

  const isSelected =
    !!selection?.somePageItemsSelected || !!selection?.allPageItemsSelected;

  return (
    <div className={clsx("nuco-table__header", className)} role="row">
      <div className="nuco-table__header-inner" style={{ gridTemplateColumns }}>
        {showSelection && (
          <div className="nuco-table__header-selection" role="columnheader">
            {!emptyState &&
              (loading ? (
                <Skeleton width="1rem" height="1rem" />
              ) : (
                <Checkbox
                  checked={isSelected}
                  indeterminate={selection.somePageItemsSelected}
                  onChange={selection.onSelectAllFromPage}
                  size="sm"
                  aria-label={t("ui.table.selectAllItemsOnPageAriaLabel")}
                />
              ))}
          </div>
        )}
        {columns.map((column) => {
          return <TableHeaderCell key={column.key} column={column} />;
        })}
      </div>
    </div>
  );
}
